import React from 'react';
import './DataPrivacyAccountDetails.css';

const DataPrivacyAccountDetails = () => {
  return (
    <div className="data-privacy-page">
      <div className="data-privacy-container">
        <h1 className="data-privacy-title">Data Privacy and Account Deletion</h1>
        
        <div className="data-privacy-intro">
          <p>
            For account deletions and data removal, please email us at <a href="mailto:info@phonevue.in">info@phonevue.in</a> with "Account Deletion Request" as the subject.
          </p>
        </div>

        <div className="data-privacy-article">
          <h2 className="article-title">Process</h2>
          <ol className="article-list">
            <li>
              After your email, we'll confirm your request via a follow-up email
            </li>
            <li>
              Respond to confirm.
            </li>
            <li>
              We'll then permanently delete your account and data from our systems.
            </li>
          </ol>
        </div>

        <div className="data-privacy-article">
          <h2 className="article-title">Please Note</h2>
          <ul className="article-list" style={{ listStyleType: 'disc' }}>
            <li>
              Deletion is irreversible.
            </li>
            <li>
              Recovery of data will not be possible.
            </li>
            <li>
              For queries or assistance, contact us at <a href="mailto:info@phonevue.in">info@phonevue.in</a>
            </li>
          </ul>
        </div>

        <div className="data-privacy-article">
          <p className="article-text" style={{ marginTop: '1.5rem', fontStyle: 'italic' }}>
            Your privacy and data security are our top priorities at PhoneVue
          </p>
        </div>
      </div>
    </div>
  );
};

export default DataPrivacyAccountDetails;
